export default __webpack_public_path__ + "static/media/08.5f0aebd1.jpg";